import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const container = this.element.dataset.selector;
    if (event.target.checked) {
      const url = this.element.dataset.fieldTranslationUrl;
      this.getTranslations(url, container);
    } else {
      const fields = $(container).find("[data-translate-field='true']");

      fields.each((_, el) => {
        const userLocale = $(el).attr(`data-lang-${i18nHelper.langCode()}`);;
        if (userLocale !== undefined) {
          $(el).val(userLocale);
        }
      });
    }
  }

  getTranslations(url, selector) {
    const fields = Array.from($(selector).find("[data-translate-field='true']")).map(el => {
      return {
        id: el.id,
        value: el.value
      }
    })

    window.$.ajax({
      type: "POST",
      data: { fields: fields, "selector": selector },
      url: url,
      dataType: 'json',
      success: function (data) {
        data.fields.forEach(({ id, value }) => {
          const el = $(data.selector).find(`#${id}`);
          Object.entries(value).forEach(([lang, translatedValue]) => {
            el.attr(`data-lang-${lang}`, translatedValue);
            if (data.default_locale_preview == lang) {
              el.val(translatedValue);
            }
          });
        })
      }
    });
  }
}
